/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import _ from 'lodash'
import ImageCompressor from 'image-compressor.js'
import { Button, Modal } from 'semantic-ui-react'
import ReactCrop from 'react-image-crop'

import ImageUpload from '../services/ImageUpload'

const imageFileTypes = ['image/png', 'image/jpeg', 'image/webp']

class SearchImageCropperUploader extends React.Component {
  static defaultProps = {
    previewWidth: 700,
    label: '',
  }

  constructor(props) {
    super(props)

    this.state = {
      image: null,
      croppedImage: null,
      uploading: false,
      compressing: false,
    }

    this.imageInputRef = React.createRef()
    this.imageRef = React.createRef()

    this.comporessor = new ImageCompressor()
  }

  getCroppedImg = (image, crop, fileName) => {
    const canvas = document.createElement('canvas')
    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    canvas.width = crop.width
    canvas.height = crop.height
    const ctx = canvas.getContext('2d')

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    )

    return new Promise(resolve => {
      canvas.toBlob(blob => {
        if (!blob) {
          console.error('Canvas is empty')
          return
        }
        blob.name = fileName

        window.URL.revokeObjectURL(this.fileUrl)

        this.fileUrl = window.URL.createObjectURL(blob)

        resolve({ url: this.fileUrl, file: blob })
      }, 'image/png')
    })
  }

  validateFile = file => {
    const { type, size } = file
    let valid = true
    let message = ''

    if (!_.includes(imageFileTypes, type)) {
      valid = false
      message = 'Image file type can be accepted as PNG or JPEG.'
    } else if (size > 3000000) {
      valid = false
      message = 'Image file size can not bigger than 3Mb.'
    }

    return {
      valid,
      message,
    }
  }

  selectFile = file => {
    this.setState({ image: URL.createObjectURL(file) })
  }

  makeClientCrop = async crop => {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImage = await this.getCroppedImg(this.imageRef, crop, 'image-crop-file.png')

      this.setState({ croppedImage })
    }
  }

  onChangeFile = e => {
    const { files } = e.target

    if (_.size(files) > 0) {
      const file = files[0]

      const validate = this.validateFile(file)

      if (validate.valid) {
        this.selectFile(file)
      } else {
        alert(validate.message)
      }
    }
  }

  onImageLoaded = image => {
    this.imageRef = image

    const { previewWidth } = this.props

    let widthToCalc = previewWidth

    if (image.width < previewWidth) {
      widthToCalc = image.width
    }

    const width = image.width > image.height ? (image.height / image.width) * widthToCalc : widthToCalc
    const height = image.height > image.width ? (image.width / image.height) * widthToCalc : widthToCalc

    const crop = {
      unit: 'px',
      aspect: 1,
      width,
      height,
      x: 0,
      y: 0,
    }

    this.setState({
      crop,
    })

    return false
  }

  onCrop = newCrop => {
    this.setState({ crop: newCrop })
  }

  onCropComplete = crop => {
    this.makeClientCrop(crop)
  }

  onClose = () => {
    const { onClose } = this.props

    this.setState(
      {
        image: null,
        croppedImage: null,
        uploading: false,
      },
      () => {
        onClose()
      }
    )
  }

  onSave = () => {
    const { croppedImage, image, crop } = this.state

    if (croppedImage && image && crop) {
      this.onUpload(croppedImage)
    } else {
      alert('Please select a photo')
    }
  }

  onBrowseClick = () => {
    this.imageInputRef.click()
  }

  onUpload = async croppedImage => {
    this.compress(croppedImage.file)
  }

  compress = croppedImagBlob => {
    const { compressWidth, compressHeight } = this.props

    this.setState({ compressing: true })

    this.comporessor
      .compress(croppedImagBlob, { quality: 0.6, width: compressWidth, height: compressHeight })
      .then(result => {
        this.setState({ compressing: false }, () => {
          this.upload(croppedImagBlob, result)
        })
      })
      .catch(err => {
        console.log(err)
        this.setState({ compressing: false })
        alert('There is problem while while compressing file. Please try again.')
      })
  }

  upload = (file, compressFile) => {
    const { uploadPath, } = this.props
    const self = this

    const imageUpload = new ImageUpload(file, 'image', {
      destination: `images/${uploadPath}`,
      type: 'item_image',
      manipulation: {
        width: 700,
        height: 0,
        size: 25000,
      },
    })

    const thumbUpload = new ImageUpload(compressFile, 'thumb', {
      destination: `images/${uploadPath}`,
      type: 'item_thumb',
      manipulation: {
        width: 250,
        height: 0,
        size: 8000,
      },
    })

    this.setState({ uploading: true })

    Promise.all([imageUpload.upload(), thumbUpload.upload()])
      .then(([image, thumb]) => {
        self.uploadSuccess(image, thumb)
      })
      .catch(() => {
        self.setState({ uploading: false })
        alert('There is problem while uploading file. Please try again.')
      })
  }

  uploadSuccess = (imageResponse, thumbResponse) => {
    const { onUploadComplete } = this.props
    // eslint-disable-next-line camelcase
    const { originalUrl: image, compressUrl: compress_image } = imageResponse
    // eslint-disable-next-line camelcase
    const { originalUrl: thumb, compressUrl: compress_thumb} = thumbResponse

    const updates = {image, thumb, compress_image, compress_thumb}

    try {
      this.setState({ uploading: false }, () => {
        onUploadComplete(updates)
        this.onClose()
      })
    } catch (err) {
      console.log(err)

      this.setState({ uploading: false })
      alert('There is problem while uploading url to db. Please try again.')
    }
  }

  renderPreviewer = () => {
    const { image, crop, uploading, compressing } = this.state

    return (
      <ReactCrop
        disabled={uploading || compressing}
        src={image}
        crop={crop}
        onChange={this.onCrop}
        onComplete={this.onCropComplete}
        onImageLoaded={this.onImageLoaded}
        style={{ margin: 'auto' }}
        minHeight={250}
        minWidth={250}
      />
    )
  }

  renderPlaceholder = () => {
    const { image, uploading, compressing } = this.state

    return (
      <div
        style={{
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          padding: image ? `10px 0px` : `30px 0px`,
        }}
      >
        {!image && <div style={{ marginBottom: 10 }}>Please select a photo</div>}
        <Button size="mini" onClick={this.onBrowseClick} disabled={uploading || compressing}>
          {image ? 'Change' : 'Browse'}
        </Button>
      </div>
    )
  }

  render() {
    const { image, compressing, uploading } = this.state
    const { previewWidth, label, visible } = this.props

    return (
      <Modal
        open={visible}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        style={{ marginTop: 0, maxWidth: previewWidth }}
      >
        <Modal.Header>{label} Picker</Modal.Header>
        <Modal.Content
          style={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            padding: 0,
            maxWidth: previewWidth,
          }}
        >
          <input
            hidden
            type="file"
            accept={_.join(imageFileTypes, ',')}
            onChange={this.onChangeFile}
            ref={ref => {
              this.imageInputRef = ref
            }}
          />
          {image && this.renderPreviewer()}
          {this.renderPlaceholder()}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onClose} negative disabled={uploading || compressing}>
            Close
          </Button>
          <Button
            onClick={this.onSave}
            disabled={uploading || compressing}
            loading={uploading || compressing}
            color="black"
            labelPosition="right"
            icon="checkmark"
            content="Save"
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

export default SearchImageCropperUploader



// WEBPACK FOOTER //
// ./src/lib/SearchImageCropperUploader.js